import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-[#EDF1F5] px-4 py-16 md:py-24" data-id="element-20" data-mp="gwx5x4ldv9es">
      <Reveal className="mx-auto max-w-3xl" data-id="element-21" data-mp="vsmmgn7suuc4">
        <div className="mb-10 text-center md:mb-12" data-id="element-22" data-mp="vuh700f5skfo">
          <div className="inline-flex rounded-full bg-brand-teal/15 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-teal" data-id="element-23" data-mp="qu2wmbq34yeh">
            INCLUDED AT NO EXTRA COST
          </div>
          <h2 className="mt-4 text-3xl font-black text-brand-blue md:text-[2.5rem]" data-id="element-24" data-mp="zurbf8naz2sf">
            5 Exclusive Bonuses for Real Teaching Challenges
          </h2>
        </div>
        <div className="space-y-3" data-id="element-25" data-mp="1elgned8l8lxc">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.07] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-26" data-mp="19l2slwvzz8h9" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue font-serif text-sm font-bold text-white" data-id="element-27" data-mp="1jk1osfzktbnd">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Cover of the ${bonus.title} bonus`} loading="lazy" decoding="async" className="h-[4.5rem] w-[4.5rem] shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-20 sm:w-20" data-id="element-28" data-mp="3tsfcemhfl5wy" />
              <div className="min-w-0 flex-1" data-id="element-29" data-mp="chz6gkxtzspa">
                <h3 className="text-[15px] font-bold leading-snug text-brand-blue" data-id="element-30" data-mp="gkc2ghms0c8v">{bonus.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-brand-gray" data-id="element-31" data-mp="ld56f3af7gjw">{bonus.description}</p>
                <span className="mt-2 inline-flex rounded-full bg-brand-teal/12 px-2.5 py-1 text-[9px] font-extrabold tracking-[0.1em] text-brand-teal" data-id="element-32" data-mp="qa5cvfb6mlbj">
                  INCLUDED
                </span>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}